// =======================
// 🧠 React та хуки
// =======================
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// =======================
// 📦 Зовнішні бібліотеки
// =======================
import Table from "antd/lib/table";
import Spin from "antd/lib/spin";
import { Empty } from "antd";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";

// =======================
// 🌐 Контексти
// =======================
import { SessionContext } from "../../../../../contexts/session/index.context";
import { SubSessionContext, SubSessionProvider } from "../../../../../contexts/session-sub/index.context";
import { ModalContext } from "../../../../../contexts/modal/index.context";
import { TableContext } from "../../../../../contexts/table/index.context";
import { DatepickerContext } from "../../../../../contexts/datepicker/index.context";
import { TranslationContext } from "../../../../../contexts/translation/index.context";

// =======================
// ⚙️ Сервіси / API
// =======================
import { request } from "../../../../../services";

// =======================
// 🧩 Утиліти / типи
// =======================
import { TableProps } from "./types";
import { MergedColumnType } from "../../utils/types";
import { useTableColumns } from "../../utils";
import { FilterValue, SorterResult, TablePaginationConfig } from "antd/es/table/interface";
import { SessionFilters } from "../../../../../contexts/session/types";

// =======================
// 🧱 Внутрішні компоненти
// =======================
import FloatButton from "../../../float-button";

// =======================
// 🎨 Стилі
// =======================
import styles from "./styles.module.scss";



export default function TableComponent(props: TableProps) {
  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const route = props.url || location.pathname;
  const [tableData, setTableData] = useState<MergedColumnType[]>([]);
    // tableData?: MergedColumnType[];
    // setTableData?: Dispatch<SetStateAction<MergedColumnType[]>>;
  const [reset, setReset] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const modalContext = useContext(ModalContext);
  const {
    // buttonStr,
    // checkboxStr,
    // rowData,
    // setRowData,
    numenclatureId,
  } = useContext(TableContext);
  const { tableState, setTableState, sessionData, setSessionData, currentPageChange } =
    useContext(SessionContext);
    const { tableStateSub, setTableStateSub, sessionDataSub, setSessionDataSub } =
      useContext(SubSessionContext);
  const [rowData, setRowData] = useState({});
  
  /**
   * Кнопки для вказання check або select radio в елементі datapickers
   */
  const [buttonStr, setButtonStr] = useState<string | undefined>(undefined);
  const [checkboxStr, setCheckboxStr] = useState<string | undefined>(undefined);

  const isElectronicMailOfDocuments =
      (props.url || location.pathname) === "/documents/electronic-mail/getfiles";
  const isScroll =
    location.pathname.split("/")[1].includes("documents") ||
    location.pathname === "/directories/nomenclature-of-cases-current" ||
    location.pathname === "/directories/employees" ||
    location.pathname === "/directories/structural-units" ||
    location.pathname === "/directories/departmental-journals";
  const tableRef = useRef(null);

  /**
   * Слідкує за зміною маршруту та очищає sessionStorage при переході на інший маршрут.
   * 
   * - Зберігає поточний маршрут у sessionStorage як `current_route`.
   * - Якщо маршрут змінився, видаляє всі ключі, що починаються з `session_data_sub_` або `table_state_sub_`.
   * - Скидає стан підпорядкованої таблиці та дані сесії.
   */
  useEffect(() => {
    const previousRoute = sessionStorage.getItem("current_route");
    const currentRoute = location.pathname;
    if (previousRoute && previousRoute !== currentRoute) {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith(`session_data_${props.nameSub}`) || key.startsWith(`table_state_${props.nameSub}`)) {
          sessionStorage.removeItem(key);
        }
      });
      setTableStateSub({
        selectedRow: undefined,
        pageSize: 15,
        currentPage: 1,
      });
      setSessionDataSub({});
    }
  }, [location]);
/**
 * Виконує оновлення таблиці, коли встановлено прапорець `refresh` у контексті модального вікна.
 * 
 * - Викликає `fetchDataTable` з `props.id` та сформованим рядком фільтрів (`buttonStr` + `checkboxStr`).
 * - Після завантаження скидає `modalContext.refresh` у `false`.
 */
  useEffect(() => {
    console.log("SUB ===== ", props.id)
    if (modalContext.refresh) {
      fetchDataTable(
        props.id,
        `${buttonStr} ${checkboxStr?.trim()}`
      );
      modalContext.setRefresh(false);
    }
  }, [modalContext.refresh]);

  useEffect(() => {
    if (buttonStr || checkboxStr !== undefined) {
      fetchDataTable(undefined, `${buttonStr} ${checkboxStr?.trim()}`);
    }
  }, [buttonStr, checkboxStr]);

  useEffect(() => {
    // Object.keys(sessionData).length > 0 &&
    //   modalContext.setDisabled({ ...modalContext.disabled, edit: false });
    Object.keys(sessionData).length > 0  &&
      fetchDataTable(
        /* isExecutors && props.activeModal === "edit" ?  */ sessionData.id ?? props.id /* : undefined */,
        `${buttonStr} ${checkboxStr?.trim()}`
      );
  }, [sessionData.id]);
  
  const fetchDataTable = async (id?: number, str?: string) => {
    setLoading(true);
    const url = isElectronicMailOfDocuments? `${props.url}`:
                  `${props.url || location.pathname}/getdatatable`;
    const content = (
      await request(url, {
        method:
          isElectronicMailOfDocuments
            ? "post"
            : "get",
        body:
          isElectronicMailOfDocuments
            ? {
                id,
                str,
                type: props.type,
                // ...(isIncomingEmail ? { email: usingEmailData } : {}),
              }
            : undefined,
        cancelTokenKey: "getsubdatatable",
      })
    )?.content;
    const dataWithKeys =
      content?.map((item: any) => ({ ...item, key: item.id })) || [];
    setTableData(dataWithKeys || []);
    currentPageChange(dataWithKeys);
    setLoading(false);
  };

  const onClickRow = async (record: any) => {
    let content;
    // if (isEmployeesAndContacts) {
    //   content = (
    //     await request(`${location.pathname}/getdatatable`, {
    //       method: "post",
    //       body: { id: record.id },
    //       cancelTokenKey: "getdatatable",
    //     })
    //   )?.content;
    // }
    modalContext.setDisabled({ ...modalContext.disabled, edit: false });
    setTableStateSub((prevState) => ({ ...prevState, selectedRow: record.id }));
    // if (props.url) {
    //   const key = props.name
    //     ? `${props.url || location.pathname}/${props.name}`
    //     : props.url || location.pathname;
    //   const newTableData = {
    //     ...rowData,
    //     [key]: { id: record.id, data: record },
    //   };
    //   setRowData(newTableData);
    // }
    setSessionDataSub(content?.[0] ?? record);
  };

  const handlePageSizeChange = (_current: number, size: number) => {
    setTableStateSub((prevState) => ({ ...prevState, pageSize: size }));
  };

  const handleCurrentPageChange = (page: number) => {
    setTableStateSub((prevState) => ({ ...prevState, currentPage: page }));
  };

  const handleOnChange = (pagination: TablePaginationConfig, filters: Record<string, FilterValue | null>, sorter: SorterResult<MergedColumnType> | SorterResult<MergedColumnType>[] ) => {
    if(pagination.current !== tableState.currentPage) return;
    const sort = (sorter as SorterResult<MergedColumnType>);
    const filtersArray = Object.entries(filters || {});
    setTableState({
      ...tableState,
      filters: filtersArray && filtersArray.length > 0 ?
        filtersArray.reduce((acc:SessionFilters[], [key, value]) => {
          value && acc.push({ columnKey: key, columnValue: value, });
          return acc;
        }
        , [])
        : undefined,
      sorter: sort && sort.columnKey && sort.field && sort.order ? {
        columnKey: sort.columnKey,
        field:  sort.field,
        order:  sort.order,
      }: undefined,
    });
  }
  
  const newSelectTableData = [
    ...tableData,
    ...(props.tableData || []).map((item, index) => ({
      ...item,
      num_pp: tableData.length + index + 1,
    })),
  ];

  return (
    <SubSessionProvider nameSub={props.nameSub}>
    <div ref={tableRef} className={styles["table-container"]} >
      <Table
        className={styles["table"]}
        key={reset ? "reset" : "not-reset"}
        columns={useTableColumns(reset, setReset, props.url, tableData)}
        locale={{
          emptyText: (
            <Empty 
              image={Empty.PRESENTED_IMAGE_SIMPLE} 
              description={intl("no-data")}
            />
          ),
        }}
        dataSource={
          props.tableData && props.tableData.length > 0
            ? newSelectTableData
            : tableData.length > 0
            ? tableData
            : []
        }
        onChange={(_, filters, sorter) => handleOnChange(_, filters, sorter)}
        onRow={(record, index) => ({
          onClick: () => {
            onClickRow(record);
          },
        })}
        rowClassName={(record, index) => {
          return record.id === tableStateSub.selectedRow
            ? styles["selected-row"]
            : "";
        }}
        // rowSelection={isEmployeesAndContactsProp ? rowSelection : undefined}
        pagination={ props.showPagination === false? false: {
          position: ["bottomCenter"],
          pageSize: tableStateSub.pageSize || 15,
          pageSizeOptions: [15, 20, 50, 100],
          showSizeChanger: true,
          onShowSizeChange: handlePageSizeChange,
          current: tableStateSub.currentPage,
          onChange: (page) => handleCurrentPageChange(page),
          locale: {
            items_per_page: intl("selector-page"), 
          },
        }}
        // scroll={{
        //   x: isScroll ? 2500 : undefined,
        //   // y: "calc(100vh - 300px)",
        // }}
        scroll={isScroll ? { x: "100vw", y: "calc(100vh)" } : undefined}
        sticky={false}
        loading={{
          spinning: loading,
          indicator: (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
          ),
        }}
        size="small"
        // bordered
      />
      <FloatButton tableRef={tableRef} />
    </div>
     </SubSessionProvider>
  );
}
